export const STORAGE_KEY = {
  userInput: 'userInput',
  storyData: 'storyData',
  recommendData: 'recommendData',
};
